var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Component, Watch, Mixins } from 'vue-property-decorator';
import { lazyInject } from '@/dependency-injection';
import { TYPES } from '@/dependency-injection/types';
import { ContractManagementService } from '@/services/contract-management/contract-management-service';
import { ReferenceDataService } from '@/services/reference-data-service';
import { SupplierService } from '@/services/supplier-service';
import { MaterialGroupService } from '@/services/material-management/material-group-service';
import { SiteService } from '@/services/site-management/site-service';
import SteppedPageMixin from '@/mixins/stepped-page-mixin';
import SnackbarMixin from '@/mixins/snackbar-mixin';
import TableMixin from '@/mixins/table-mixin';
import UtilsMixin from '@/mixins/utils-mixin';
import { ValidationObserver } from 'vee-validate';
import UploadButton from '@/components/shared/UploadButton.vue';
import ValidatedTextField from '@/components/shared/ValidatedTextField.vue';
import ValidatedTextarea from '@/components/shared/ValidatedTextarea.vue';
import ValidatedAutocomplete from '@/components/shared/ValidatedAutocomplete.vue';
import ValidatedCheckbox from '@/components/shared/ValidatedCheckbox.vue';
import DatePicker from '@/components/shared/DatePicker.vue';
import fileDownload from 'js-file-download';
import { mask } from 'vue-the-mask';
import * as isAfter from 'date-fns/is_after';
import * as isBefore from 'date-fns/is_before';
import * as parse from 'date-fns/parse';
import * as format from 'date-fns/format';
import * as addDays from 'date-fns/add_days';
import * as uuid_v4 from 'uuid/v4';
var Details = /** @class */ (function (_super) {
    __extends(Details, _super);
    function Details() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // validations
        _this.validationRules = {};
        _this.referenceDataLoaded = false;
        _this.datePickers = {
            start: false,
            startTime: false,
            end: false,
            extended: false,
        };
        _this.options = {
            contractTypes: [],
            suppliers: [],
            materialGroups: [],
            indexMarkets: [],
            paymentTerms: [],
            statuses: [],
            cancellationReasons: [],
            times: [],
            contractFiles: [],
        };
        // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/file#accept
        _this.supportedFileTypesList = [
            'application/pdf',
        ];
        _this.contractFile = {};
        _this.startDatePicker = false;
        _this.endDatePicker = false;
        _this.revisedEndDatePicker = false;
        _this.actualEndDatePicker = false;
        _this.mostRecentBidDatePicker = false;
        return _this;
    }
    Details.prototype.allowedDates = function (val) {
        var date = new Date(val);
        return date >= addDays(new Date(), -60)
            && date <= addDays(new Date(), 5);
    };
    Details.prototype.beforeMount = function () {
        this.serviceSymbol = TYPES.ContractManagementService;
    };
    Details.prototype.mounted = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.validationRules = this.contractManagementService.getValidationRules();
                this.referenceDataLoaded = false;
                return [2 /*return*/];
            });
        });
    };
    Details.prototype.getReferenceData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var referenceDataResponse, suppliersResponse, _a, getAllMarkets;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        // if we have already loaded the reference data, don't load again
                        if (this.referenceDataLoaded) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.referenceDataService.getModulesByRequest({ modules: [
                                    'VENDOR_CONTRACT_TYPES',
                                    'CONTRACT_PAYMENT_TERMS',
                                    'CONTRACT_STATUSES',
                                    'CONTRACT_CANCELLATION_REASONS',
                                ], includeDeleted: false })];
                    case 1:
                        referenceDataResponse = _b.sent();
                        // contract types
                        this.options.contractTypes = referenceDataResponse.success
                            ? referenceDataResponse.data.filter(function (item) { return item.module === 'VENDOR_CONTRACT_TYPES'; }).sort(function (a, b) {
                                if (a.code > b.code) {
                                    return 1;
                                }
                                if (a.code < b.code) {
                                    return -1;
                                }
                                return 0;
                            })
                            : [];
                        return [4 /*yield*/, this.supplierService.getAllRef()];
                    case 2:
                        suppliersResponse = _b.sent();
                        this.options.suppliers = suppliersResponse.success
                            ? suppliersResponse.data.sort(function (a, b) {
                                if (a.supplierId > b.supplierId) {
                                    return 1;
                                }
                                if (a.supplierId < b.supplierId) {
                                    return -1;
                                }
                                return 0;
                            })
                            : [];
                        // material groups
                        _a = this.options;
                        return [4 /*yield*/, this.materialGroupService.getAllRef()];
                    case 3:
                        // material groups
                        _a.materialGroups = (_b.sent()).data;
                        return [4 /*yield*/, this.siteService.getAllMarkets()];
                    case 4:
                        getAllMarkets = _b.sent();
                        this.options.indexMarkets = getAllMarkets.success
                            ? getAllMarkets.data.sort(function (a, b) {
                                if (a.marketId > b.marketId) {
                                    return 1;
                                }
                                if (a.marketId < b.marketId) {
                                    return -1;
                                }
                                return 0;
                            })
                            : [];
                        // payment terms
                        this.options.paymentTerms = referenceDataResponse.success
                            ? referenceDataResponse.data.filter(function (item) { return item.module === 'CONTRACT_PAYMENT_TERMS'; }).sort(function (a, b) {
                                if (a.code > b.code) {
                                    return 1;
                                }
                                if (a.code < b.code) {
                                    return -1;
                                }
                                return 0;
                            })
                            : [];
                        // statuses
                        this.options.statuses = referenceDataResponse.success
                            ? referenceDataResponse.data.filter(function (item) { return item.module === 'CONTRACT_STATUSES'; }).sort(function (a, b) {
                                if (a.code > b.code) {
                                    return 1;
                                }
                                if (a.code < b.code) {
                                    return -1;
                                }
                                return 0;
                            })
                            : [];
                        // cancellation reason
                        this.options.cancellationReasons = referenceDataResponse.success
                            ? referenceDataResponse.data.filter(function (item) { return item.module === 'CONTRACT_CANCELLATION_REASONS'; }).sort(function (a, b) {
                                if (a.code > b.code) {
                                    return 1;
                                }
                                if (a.code < b.code) {
                                    return -1;
                                }
                                return 0;
                            })
                            : [];
                        this.options.times = this.contractManagementService.getHours();
                        this.referenceDataLoaded = true;
                        return [2 /*return*/];
                }
            });
        });
    };
    Details.prototype.isDateBefore = function (date, otherDate) {
        return !otherDate || isBefore(parse(date), parse(otherDate));
    };
    Details.prototype.isDateAfter = function (date, otherDate) {
        return !otherDate || isAfter(parse(date), parse(otherDate));
    };
    Object.defineProperty(Details.prototype, "filteredStatuses", {
        get: function () {
            var status = this.item.status;
            var statuses = this.options.statuses;
            if (status === 'A') {
                var aStatuses = statuses.filter(function (s) {
                    return s.code === 'CA' || s.code === 'CO' || s.code === status;
                });
                return aStatuses;
            }
            else if (status === 'P') {
                var pStatuses = statuses.filter(function (s) {
                    return s.code === 'CA' || s.code === status;
                });
                return pStatuses;
            }
            else if (!status || status.length <= 0) {
                var apStatuses = statuses.filter(function (s) {
                    return s.code === 'A' || s.code === 'P';
                });
                return apStatuses;
            }
            else {
                var origStatus = statuses.filter(function (s) {
                    return s.code === status;
                });
                return origStatus;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Details.prototype, "formattedStartDate", {
        get: function () {
            var contract = __assign({}, this.item);
            if (contract && contract.startDate) {
                return contract.startDate !== ''
                    ? format(contract.startDate, 'MM/DD/YYYY')
                    : '';
            }
            else {
                return '';
            }
        },
        set: function (newValue) {
            var contract = __assign({}, this.item);
            if (contract && newValue && newValue.length === 10) {
                contract.startDate = format(new Date(newValue), 'YYYY-MM-DD');
                this.item = contract;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Details.prototype, "contractStartTime", {
        get: function () {
            var contract = __assign({}, this.item);
            if (contract && contract.startDate) {
                return contract.startDate !== ''
                    ? this.formatTime(contract.startDate)
                    : '';
            }
            else {
                return '';
            }
        },
        set: function (newValue) {
            var contract = __assign({}, this.item);
            if (contract && contract.startDate) {
                var currentStartTime = this.formatTime(contract.startDate);
                if (currentStartTime !== newValue) {
                    contract.startDate = format(contract.startDate, 'YYYY-MM-DD') + ' ' + newValue;
                    this.item = contract;
                }
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Details.prototype, "formattedEndDate", {
        get: function () {
            var contract = __assign({}, this.item);
            if (contract && contract.endDate) {
                return contract.endDate !== ''
                    ? format(contract.endDate, 'MM/DD/YYYY')
                    : '';
            }
            else {
                return '';
            }
        },
        set: function (newValue) {
            var contract = __assign({}, this.item);
            if (contract && newValue && newValue.length === 10) {
                contract.endDate = format(new Date(newValue), 'YYYY-MM-DD');
                this.item = contract;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Details.prototype, "contractEndTime", {
        get: function () {
            var contract = __assign({}, this.item);
            if (contract && contract.endDate) {
                return contract.endDate !== ''
                    ? this.formatTime(contract.endDate)
                    : '';
            }
            else {
                return '';
            }
        },
        set: function (newValue) {
            var contract = __assign({}, this.item);
            if (contract && contract.endDate) {
                var currentEndTime = this.formatTime(contract.endDate);
                if (currentEndTime !== newValue) {
                    contract.endDate = format(contract.endDate, 'YYYY-MM-DD') + ' ' + newValue;
                    this.item = contract;
                }
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Details.prototype, "formattedRevisedEndDate", {
        get: function () {
            var contract = __assign({}, this.item);
            if (contract && contract.revisedEndDate) {
                return contract.revisedEndDate !== ''
                    ? format(contract.revisedEndDate, 'MM/DD/YYYY')
                    : '';
            }
            else {
                return '';
            }
        },
        set: function (newValue) {
            var contract = __assign({}, this.item);
            if (contract && newValue && newValue.length === 10) {
                contract.revisedEndDate = format(new Date(newValue), 'YYYY-MM-DD');
                this.item = contract;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Details.prototype, "contractRevisedEndTime", {
        get: function () {
            var contract = __assign({}, this.item);
            if (contract && contract.revisedEndDate) {
                return contract.revisedEndDate !== ''
                    ? this.formatTime(contract.revisedEndDate)
                    : '';
            }
            else {
                return '';
            }
        },
        set: function (newValue) {
            var contract = __assign({}, this.item);
            if (contract && contract.revisedEndDate) {
                var currentRevisedEndTime = this.formatTime(contract.revisedEndDate);
                if (currentRevisedEndTime !== newValue) {
                    contract.revisedEndDate = format(contract.revisedEndDate, 'YYYY-MM-DD') + ' ' + newValue;
                    this.item = contract;
                }
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Details.prototype, "formattedActualEndDate", {
        get: function () {
            var contract = __assign({}, this.item);
            if (contract && contract.actualEndDate) {
                return contract.actualEndDate !== ''
                    ? format(contract.actualEndDate, 'MM/DD/YYYY')
                    : '';
            }
            else {
                return '';
            }
        },
        set: function (newValue) {
            var contract = __assign({}, this.item);
            if (contract && newValue && newValue.length === 10) {
                contract.actualEndDate = format(new Date(newValue), 'YYYY-MM-DD');
                this.item = contract;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Details.prototype, "contractActualEndTime", {
        get: function () {
            var contract = __assign({}, this.item);
            if (contract && contract.actualEndDate) {
                return contract.actualEndDate !== ''
                    ? this.formatTime(contract.actualEndDate)
                    : '';
            }
            else {
                return '';
            }
        },
        set: function (newValue) {
            var contract = __assign({}, this.item);
            if (contract && contract.actualEndDate) {
                var currentActualEndTime = this.formatTime(contract.actualEndDate);
                if (currentActualEndTime !== newValue) {
                    contract.actualEndDate = format(contract.actualEndDate, 'YYYY-MM-DD') + ' ' + newValue;
                    this.item = contract;
                }
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Details.prototype, "formattedMostRecentBidDate", {
        get: function () {
            var contract = __assign({}, this.item);
            if (contract && contract.mostRecentBidDate) {
                return contract.mostRecentBidDate !== ''
                    ? format(contract.mostRecentBidDate, 'MM/DD/YYYY')
                    : '';
            }
            else {
                return '';
            }
        },
        set: function (newValue) {
            var contract = __assign({}, this.item);
            if (contract && newValue && newValue.length === 10) {
                contract.mostRecentBidDate = format(new Date(newValue), 'YYYY-MM-DD');
                this.item = contract;
            }
        },
        enumerable: false,
        configurable: true
    });
    Details.prototype.formatTime = function (date) {
        return format(date, 'HH:mm');
    };
    Object.defineProperty(Details.prototype, "contactFirstName", {
        get: function () {
            var contacts = __assign({}, this.item).contacts;
            if (contacts && contacts[0] && contacts[0].firstName) {
                return contacts[0].firstName;
            }
            else {
                return '';
            }
        },
        set: function (newValue) {
            var contacts = __assign({}, this.item).contacts;
            if (contacts && contacts[0]) {
                var currentFirstName = contacts[0].firstName;
                if (currentFirstName !== newValue) {
                    contacts[0].firstName = newValue;
                }
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Details.prototype, "contactLastName", {
        get: function () {
            var contacts = __assign({}, this.item).contacts;
            if (contacts && contacts[0] && contacts[0].lastName) {
                return contacts[0].lastName;
            }
            else {
                return '';
            }
        },
        set: function (newValue) {
            var contacts = __assign({}, this.item).contacts;
            if (contacts && contacts[0]) {
                var currentLastName = contacts[0].lastName;
                if (currentLastName !== newValue) {
                    contacts[0].lastName = newValue;
                }
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Details.prototype, "contactOfficePhone", {
        get: function () {
            var _this = this;
            var contacts = __assign({}, this.item).contacts;
            if (contacts && contacts.length > 0) {
                var salesRepContacts = contacts
                    .filter(function (c) {
                    return c.contactType === _this.salesrepContactType();
                });
                if (salesRepContacts && salesRepContacts.length > 0) {
                    return salesRepContacts[0].officePhone;
                }
                else {
                    return '';
                }
            }
            else {
                return '';
            }
        },
        set: function (newValue) {
            var _this = this;
            var contacts = __assign({}, this.item).contacts;
            if (contacts && contacts.length > 0) {
                var salesRepContacts = contacts
                    .filter(function (c) {
                    return c.contactType === _this.salesrepContactType();
                });
                if (salesRepContacts && salesRepContacts.length > 0) {
                    var currentSalesRepPhone = salesRepContacts[0].officePhone;
                    if (currentSalesRepPhone !== newValue) {
                        salesRepContacts[0].officePhone = newValue;
                    }
                }
                else {
                    this.updateContacts(newValue, this.salesrepContactType(), this.officePhoneType());
                }
            }
            else {
                this.updateContacts(newValue, this.salesrepContactType(), this.officePhoneType());
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Details.prototype, "contactCellPhone", {
        get: function () {
            var _this = this;
            var contacts = __assign({}, this.item).contacts;
            if (contacts && contacts.length > 0) {
                var salesRepContacts = contacts
                    .filter(function (c) {
                    return c.contactType === _this.salesrepContactType();
                });
                if (salesRepContacts && salesRepContacts.length > 0) {
                    return salesRepContacts[0].cellPhone;
                }
                else {
                    return '';
                }
            }
            else {
                return '';
            }
        },
        set: function (newValue) {
            var _this = this;
            var contacts = __assign({}, this.item).contacts;
            if (contacts && contacts.length > 0) {
                var salesRepContacts = contacts
                    .filter(function (c) {
                    return c.contactType === _this.salesrepContactType();
                });
                if (salesRepContacts && salesRepContacts.length > 0) {
                    var currentSalesRepPhone = salesRepContacts[0].cellPhone;
                    if (currentSalesRepPhone !== newValue) {
                        salesRepContacts[0].cellPhone = newValue;
                    }
                }
                else {
                    this.updateContacts(newValue, this.salesrepContactType(), this.cellPhoneType());
                }
            }
            else {
                this.updateContacts(newValue, this.salesrepContactType(), this.cellPhoneType());
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Details.prototype, "contactEmail", {
        get: function () {
            var contacts = __assign({}, this.item).contacts;
            if (contacts && contacts[0] && contacts[0].email) {
                return contacts[0].email;
            }
            else {
                return '';
            }
        },
        set: function (newValue) {
            var contacts = __assign({}, this.item).contacts;
            if (contacts && contacts[0]) {
                var currentEmail = contacts[0].email;
                if (currentEmail !== newValue) {
                    contacts[0].email = newValue;
                }
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Details.prototype, "contactHelpDeskPhone", {
        get: function () {
            var _this = this;
            var contacts = __assign({}, this.item).contacts;
            if (contacts && contacts.length > 0) {
                var helpDeskContacts = contacts
                    .filter(function (c) {
                    return c.contactType === _this.helpdeskContactType();
                });
                if (helpDeskContacts.length > 0) {
                    return helpDeskContacts[0].officePhone;
                }
                else {
                    return '';
                }
            }
            else {
                return '';
            }
        },
        set: function (newValue) {
            var _this = this;
            var contacts = __assign({}, this.item).contacts;
            if (contacts && contacts.length > 0) {
                var helpDeskContacts = contacts
                    .filter(function (c) {
                    return c.contactType === _this.helpdeskContactType();
                });
                if (helpDeskContacts && helpDeskContacts.length > 0) {
                    var currentHelpDeskPhone = helpDeskContacts[0].officePhone;
                    if (currentHelpDeskPhone !== newValue) {
                        helpDeskContacts[0].officePhone = newValue;
                    }
                }
                else {
                    this.updateContacts(newValue, this.helpdeskContactType(), this.officePhoneType());
                }
            }
            else {
                this.updateContacts(newValue, this.helpdeskContactType(), this.officePhoneType());
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Details.prototype, "daysNoticeValidationRule", {
        get: function () {
            var contract = this.item;
            return contract.isCancellable ? { numeric: true, required: true } : {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Details.prototype, "cancellationReasonValidationRule", {
        get: function () {
            var contract = this.item;
            return contract.status === 'CA' ? { required: true } : {};
        },
        enumerable: false,
        configurable: true
    });
    Details.prototype.updateContacts = function (newValue, contactType, phoneType) {
        var contact = {};
        var contract = __assign({}, this.item);
        contact.contactId = this.getUniqueId();
        contact.contractId = contract.contractId;
        contact.contactType = contactType;
        if (phoneType === this.cellPhoneType()) {
            contact.cellPhone = newValue;
        }
        else if (phoneType === this.officePhoneType()) {
            contact.officePhone = newValue;
        }
        // locally update collection
        contract.contacts = this.updateItemsCollection(contract.contacts, contact, ['contactId', 'contractId']);
        // update item we are looking at
        this.item = contract;
    };
    Details.prototype.getUniqueId = function () {
        return uuid_v4();
    };
    Details.prototype.salesrepContactType = function () {
        return 'SALES REP';
    };
    Details.prototype.cellPhoneType = function () {
        return 'CELL';
    };
    Details.prototype.officePhoneType = function () {
        return 'OFFICE';
    };
    Details.prototype.helpdeskContactType = function () {
        return 'HELP DESK';
    };
    Details.prototype.onStepChanged = function (val, oldVal) {
        if (val && val !== oldVal && val === 'D') {
            this.getReferenceData();
        }
    };
    Details.prototype.download = function (item) {
        return __awaiter(this, void 0, void 0, function () {
            var charIndex, id, name, response, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        charIndex = item.indexOf(':::');
                        id = item.substring(0, charIndex);
                        name = item.substring(charIndex + 3);
                        return [4 /*yield*/, this.contractManagementService.getContractFile(id)];
                    case 1:
                        response = _a.sent();
                        fileDownload(response, name);
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        console.error(error_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Details.prototype.isEvergreenChanged = function (checked) {
        if (checked) {
            var contract = __assign({}, this.item);
            contract.revisedEndDate = null;
            this.item = contract;
        }
    };
    Details.prototype.materialGroupChanged = function (materialGroupId) {
        var contract = __assign({}, this.item);
        contract.defaultAllocationPeriod = 'MONTHLY';
        this.item = contract;
    };
    Details.prototype.contractStatusChanged = function (statusId) {
        var contract = __assign({}, this.item);
        contract.cancellationReason = null;
        this.item = contract;
    };
    Details.prototype.contractFileChanged = function (file) {
        var contract = __assign({}, this.item);
        // check for duplicate period
        var matchingFiles = contract.contractFiles
            .filter(function (cf) {
            return cf.fileName === file.name;
        });
        if (matchingFiles.length > 0) {
            // show an error to the user, and do not update local collection
            this.showSnackbar({
                text: 'This file has already been uploaded to this contract',
                color: 'error',
            });
        }
        else {
            this.contractFile = file;
            contract.contractFile = file;
            this.item = contract;
        }
    };
    Details.prototype.getContractFileValidationRules = function () {
        var rules = __assign({}, this.contractManagementService.getContractFileValidationRules());
        return rules;
    };
    Object.defineProperty(Details.prototype, "supportedFileTypes", {
        get: function () {
            return this.supportedFileTypesList.join(',');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Details.prototype, "fileName", {
        get: function () {
            return this.contractFile ? this.contractFile.name : '';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Details.prototype, "isExistingContract", {
        get: function () {
            return (this.$route.params &&
                this.$route.params.id &&
                this.$route.params.id !== '0');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Details.prototype, "isDuplicateContract", {
        get: function () {
            return this.$route.path.endsWith('duplicate');
        },
        enumerable: false,
        configurable: true
    });
    var _a, _b, _c, _d, _e;
    __decorate([
        lazyInject(TYPES.ContractManagementService),
        __metadata("design:type", typeof (_a = typeof ContractManagementService !== "undefined" && ContractManagementService) === "function" ? _a : Object)
    ], Details.prototype, "contractManagementService", void 0);
    __decorate([
        lazyInject(TYPES.ReferenceDataService),
        __metadata("design:type", typeof (_b = typeof ReferenceDataService !== "undefined" && ReferenceDataService) === "function" ? _b : Object)
    ], Details.prototype, "referenceDataService", void 0);
    __decorate([
        lazyInject(TYPES.SupplierService),
        __metadata("design:type", typeof (_c = typeof SupplierService !== "undefined" && SupplierService) === "function" ? _c : Object)
    ], Details.prototype, "supplierService", void 0);
    __decorate([
        lazyInject(TYPES.MaterialGroupService),
        __metadata("design:type", typeof (_d = typeof MaterialGroupService !== "undefined" && MaterialGroupService) === "function" ? _d : Object)
    ], Details.prototype, "materialGroupService", void 0);
    __decorate([
        lazyInject(TYPES.SiteService),
        __metadata("design:type", typeof (_e = typeof SiteService !== "undefined" && SiteService) === "function" ? _e : Object)
    ], Details.prototype, "siteService", void 0);
    __decorate([
        Watch('step', { immediate: true, deep: false }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Object]),
        __metadata("design:returntype", void 0)
    ], Details.prototype, "onStepChanged", null);
    Details = __decorate([
        Component({
            components: {
                'validation-observer': ValidationObserver,
                'validated-text-field': ValidatedTextField,
                'validated-text-area': ValidatedTextarea,
                'validated-autocomplete': ValidatedAutocomplete,
                'validated-checkbox': ValidatedCheckbox,
                'upload-button': UploadButton,
                'date-picker': DatePicker,
            },
            directives: {
                mask: mask,
            },
        })
    ], Details);
    return Details;
}(Mixins(SteppedPageMixin, SnackbarMixin, TableMixin, UtilsMixin)));
export default Details;
